import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="site-footer" style={{
      width: '100%',
      background: '#222',
      color: '#fff',
      textAlign: 'center',
      padding: '20px 0',
      marginTop: 'auto',
      fontSize: 16
    }}>
      {/* <p style={{ fontSize: 20}}><a href="https://mold-day-event.web.app/">世界防霉日 Global Mold Awareness Day</a></p>
      <br /> */}
      Copyright © 2025 <a href="https://ycm.group/">YCM Products CO., LTD.</a> 優克美科技股份有限公司｜No.509, 金馬路一段 彰化市彰化縣500
    </footer>
  );
}
